/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public sendTestNotification({
    type,
  }: {
    type: 'DEFAULT' | 'UBI' | 'EV_BATTERY' | 'PROPAGATION' | 'HMG_PROFILE' | 'HMG_PRIVACY' | 'CCSP_PROFILE',
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/notifications/{type}',
      path: {
        'type': type,
      },
    });
  }
}
